export const MAIN_CONTENT_PADDING_CLASS =
  "[--main-content-pad-y:--spacing(2)] lg:[--main-content-pad-y:--spacing(3)] py-(--main-content-pad-y) px-2 lg:px-4"

/**
 * Sticky travel stops at a scrollport's padding, not its visible edge, so these
 * subtract `--main-content-pad-y` to pin flush. Only for elements whose nearest
 * scrollport is `#main-content`: the variable also inherits into nested
 * scrollports, whose padding it does not describe.
 */
export const MAIN_CONTENT_STICKY_TOP_CLASS =
  "sticky top-[calc(-1*var(--main-content-pad-y,0px))]"

export const MAIN_CONTENT_STICKY_BOTTOM_CLASS =
  "sticky bottom-[calc(-1*var(--main-content-pad-y,0px))]"
